export abstract class InvoiceException extends Error {

}